<template>
<div class="img_preview" v-show="showBox">
    <div class="title">
        <div class="back_desc" @click="hideBox">
            <img src="//img.58cdn.com.cn/m58/img/pointer_left.png">
        </div>
        <div class="title_div">
            <span class="preview_title">简历头像</span>
        </div>
    </div>
    <div class="picture_div">
        <img class="picture" :src="imgUrl" :class="imgClass">
        <div class="change_img" @click="changeImg">
            <span>更换头像</span>
        </div>
    </div>
</div>
</template>
<script>
export default {
	props: {
		imgSrc: {
			type: String,
			default: ''
		},
		value: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			showBox: false,
			imgUrl: '',
			imgClass: ''
		};
	},
	watch: {
		value(val) {
			this.showBox = val;
		},
		showBox(val) {
			this.$emit('input', val);
		},
		imgSrc(val) {
			// 默认头像,大图展示为200*200的图片
			let array = val.split('/');
			if (array.indexOf('img.58cdn.com.cn') > -1) {
				this.imgUrl = val.replace('_126.png', '_200.png');
			} else {
				this.imgUrl = val;
			}
		}
	},
	mounted() {
		let clientWidth = document.documentElement.clientWidth,
			clientHeight = document.documentElement.clientHeight;

		if (clientWidth / clientHeight > 0.65) {
			this.imgClass = 'picture-short';
		}
	},
	methods: {
		hideBox() {
			this.showBox = false;
		},
		changeImg() {
			this.hideBox();
			this.$emit('changImg');
		}
	}
};
</script>
<style lang="scss" scoped>
@import '../../../assets/style/public.scss';
.img_preview {
	width: 100%;
	height: 100%;
	position: fixed;
	z-index: 1000;
	top: 0;
	left: 0;
	background: #000;
}
.title {
	width: 100%;
	height: px2rem(88px);
	background: #e0e0e0;
	line-height: px2rem(88px);
}
.back_desc {
	height: px2rem(88px);
	width: px2rem(80px);
	text-align: left;
	img {
		width: px2rem(22px);
		height: px2rem(42px);
		margin-left: px2rem(20px);
		margin-top: px2rem(20px);
	}
}
.title_div {
	width: px2rem(200px);
	height: px2rem(88px);
	background: #e0e0e0;
	line-height: px2rem(88px);
	display: inline;
	text-align: center;
	position: absolute;
	left: 50%;
	top: 0;
	margin-left: px2rem(-100px);
	font-size: px2rem(32px);
	color: #333;
}
.preview_title {
	font-size: px2rem(32px);
	color: #333;
	text-align: center;
}
.picture {
	width: 100%;
	height: 100vw;
	display: block;
	margin: px2rem(160px) 0 px2rem(75px);
	display: block;
}
.picture-short {
	margin: px2rem(75px) 0 px2rem(28px);
}
.change_img {
	width: px2rem(300px);
	height: px2rem(90px);
	line-height: px2rem(82px);
	border: px2rem(4px) solid #e0e0e0;
	text-align: center;
	vertical-align: middle;
	margin: 0 auto;
	color: #e0e0e0;
	font-size: px2rem(32px);
	border-radius: px2rem(90px);
}
</style>



// WEBPACK FOOTER //
// preview.vue?0d5e44e3